<template>
  <Voucher :footerText="$t('common.redeemed')" class="voucher-wrapper">
    <template v-slot:main>
      <div class="image-wrapper">
        <img alt="ban" src="@/assets/images/icon/ban.png" />
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-wrapper">{{ $t('promotion.referFriends.rejectedVoucher') }}</div>
    </template>
  </Voucher>
</template>

<script>
import Voucher from './Voucher.vue';

export default {
  name: 'RejectedVoucher',
  components: {
    Voucher
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/notApplicableVoucher.scss';
</style>
